// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import './mytheme/index.less';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import MyRouter from './utils/myRouter'
import Promise from 'es6-promise'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/main.css'
import UiUtils from './utils/uiUtils'
import VueLazyLoad from 'vue-lazyload'
import resizemgr from './utils/resizemgr'
import * as echarts from 'echarts';
// import { ImagePreview } from 'vant';

Vue.use(ElementUI);
Vue.use(VueLazyLoad);
// Vue.use(ImagePreview);

Promise.polyfill()

Vue.prototype.$resizemgr = resizemgr;
Vue.prototype.$echarts = echarts;
//Vue.use(echarts);

window.onresize = function() {
    resizemgr.onReSize();
}

Vue.prototype.$UiUtils = UiUtils;
Vue.prototype.$MyRouter = MyRouter;

Vue.config.productionTip = false

Vue.use(ViewUI);
Vue.use(VueAwesomeSwiper);
// Vue.component('v-chart', ECharts);

Vue.prototype.$Message.config({
  top: 100,
  duration: 2
});
Vue.prototype.$Notice.config({
  top: 50,
  duration: 3
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    watch: {
      '$route.name': function (newVal, oldVal) {

      }
     }
  })



// WEBPACK FOOTER //
// ./src/main.js